<template>
  <div class="modal-wrapper">
    <BasicModal
      :title="'メール' + (user.companySMSTEL ? ' / SMS' : '') + '（' +  selectEmailSeeker.name + '）'"
      :isShowModal=isShowModal
      :canCancel="true"
      @cancel="cancel">
      <article class="container">
        <!-- メニュー -->
        <section v-if="!isOpenSendEmailList && !isOpenSendSMSList">
          <div>
            <button class="button is-primary is-fullwidth"
              @click="openSendEmailMenu()">
              メールを送付する
            </button>
          </div>
          <div class="button-wrapper">
            <button class="button is-primary is-fullwidth"
              @click="openSendedEmailList()">
              メール送受信履歴
            </button>
          </div>
          <div class="button-wrapper" v-if="user.companySMSTEL">
            <button class="button is-primary is-fullwidth"
              @click="openSendSMSMenu()">
              SMSを送付する
            </button>
          </div>
          <div class="button-wrapper" v-if="user.companySMSTEL">
            <button class="button is-primary is-fullwidth"
              @click="openSendedSMSList()">
              SMS送受信履歴
            </button>
          </div>

        </section>
        <!-- メール送受信履歴 -->
        <section class="main-section" v-if="isOpenSendEmailList && sendedEmailList.length">
          <p>メール送受信履歴</p>
          <article class="table-wrapper">
            <!-- テーブル一覧 -->
            <EmailLogTable :sendedEmailList="sendedEmailList"
              :user="user"
              @clickEmailDetailButton="clickEmailDetailButton"/>
            <!-- メール詳細 -->
            <EmailDetail v-if="isClickEmailDetailButton"
              :selectSended="selectSended"
              :enablePrev="emailDetailStatus.enablePrev"
              :enableNext="emailDetailStatus.enableNext"
              @clickPrev="clickPrev"
              @clickNext="clickNext"
              @clickCloseBtn="clickCloseBtn"/>
          </article>
        </section>
        <!-- 送付済みメール情報 メール未送付の場合 -->
        <section v-if="isOpenSendEmailList && sendedEmailList.length === 0">
          <p>この訪問者へはまだメールをお送りしておりません。</p>
        </section>
        <!-- SMS送付履歴 -->
        <section class="main-section" v-if="isOpenSendSMSList && sendedSMSList.length">
          <p>SMS送受信履歴</p>
          <article class="table-wrapper">
            <!-- テーブル一覧 -->
            <SMSLogTable :sendedEmailList="sendedSMSList"
            @clickSMSDetailButton="clickSMSDetailButton"/>
            <!-- SMS詳細 -->
            <SMSDetail v-if="isClickSMSDetailButton"
              :selectSended="selectSended"
              :enablePrev="SMSDetailStatus.enablePrev"
              :enableNext="SMSDetailStatus.enableNext"
              @clickPrev="clickPrev"
              @clickNext="clickNext"
              @clickCloseBtn="clickCloseBtn"/>
          </article>
        </section>
        <!-- 送付済みSMS情報 SMS未送付の場合 -->
        <section v-if="isOpenSendSMSList && sendedSMSList.length === 0">
          <p>この訪問者へはまだSMSをお送りしておりません。</p>
        </section>
      </article>
    </BasicModal>
  </div>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
import EmailLogTable from '@/components/molecules/tables/EmailLogTable'
import EmailDetail from '@/components/organisms/articles/EmailDetail'
import SMSLogTable from '@/components/molecules/tables/SMSLogTable'
import SMSDetail from '@/components/organisms/articles/SMSDetail'
export default {
  components: {
    BasicModal,
    EmailLogTable,
    EmailDetail,
    SMSLogTable,
    SMSDetail
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: false,
      default: false
    },
    selectEmailSeeker: {
      type: Object,
      required: false
    },
    user: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      isOpenSendEmailList: false,
      isOpenSendSMSList: false,
      sendedEmailList: [],
      sendedSMSList: [],
      isClickEmailDetailButton: false,
      isClickSMSDetailButton: false,
      selectSended: [],
      emailDetailStatus: {enablePrev: true, enableNext: false},
      SMSDetailStatus: {enablePrev: true, enableNext: false}
    }
  },
  watch: {
    isShowModal() {
      if (this.isShowModal) {
        this.getSendedEmailList()
      }
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel', false)
      this.isOpenSendEmailList = false
      this.isOpenSendSMSList = false
      this.isClickEmailDetailButton = false
      this.isClickSMSDetailButton = false
    },
    openSendEmailMenu () {
      this.$emit('openSendEmailMenu', this.selectEmailSeeker)
      this.cancel()
    },
    openSendSMSMenu () {
      this.$emit('openSendSMSMenu', this.selectEmailSeeker)
      this.cancel()
    },
    openSendedEmailList () {
      this.isOpenSendEmailList = true
    },
    openSendedSMSList () {
      this.isOpenSendSMSList = true
    },
    getSendedEmailList () {
      this.$store.dispatch("directtalk/getSendedEmailList", this.selectEmailSeeker.id)
        .then((data) => {
          this.sendedEmailList = data
        })
      this.$store.dispatch("directtalk/getSendedSMSList", this.selectEmailSeeker.id)
        .then((data) => {
          this.sendedSMSList = data
        })
    },
    selectEmailDetailIndex (idx) {
      if (idx < 0 || idx >= this.sendedEmailList.length) return
      this.selectSended = this.sendedEmailList[idx]
      this.emailDetailStatus.enableNext = (idx != 0)
      this.emailDetailStatus.enablePrev = (idx != this.sendedEmailList.length-1)
    },
    selectSMSDetailIndex (idx) {
      if (idx < 0 || idx >= this.sendedSMSList.length) return
      this.selectSended = this.sendedSMSList[idx]
      this.SMSDetailStatus.enableNext = (idx != 0)
      this.SMSDetailStatus.enablePrev = (idx != this.sendedSMSList.length-1)
    },
    clickEmailDetailButton (sended) {
      this.isClickEmailDetailButton = true
      const idx = this.sendedEmailList.findIndex((item) => item == sended)
      this.selectEmailDetailIndex(idx)
    },
    clickSMSDetailButton (sended) {
      this.isClickSMSDetailButton = true
      const idx = this.sendedSMSList.findIndex((item) => item == sended)
      this.selectSMSDetailIndex(idx)
    },
    clickPrev () {
      const idx = this.sendedEmailList.findIndex((item) => item == this.selectSended)
      this.selectEmailDetailIndex(idx+1)
    },
    clickNext () {
      const idx = this.sendedEmailList.findIndex((item) => item == this.selectSended)
      this.selectEmailDetailIndex(idx-1)
    },
    clickCloseBtn () {
      this.isClickEmailDetailButton = false
      this.isClickSMSDetailButton = false
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-wrapper {
  .container {
    padding: 8px;
    height: 600px;
    display: flex;
    align-items: center;
    overflow: auto;
    section {
      width: 100%;
    }
  }
  .button-wrapper {
    margin-top: 16px;
  }
  .table-wrapper {
    display: flex;
    justify-content: center;
    height: 100%;
    position: relative;
    padding: 8px;
  }
  .main-section {
    height: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/organisms/modals/ModalSelectEmail.vue